import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';

import { SurveyField } from '../types';

import { SurveyFieldForm } from './SurveyFieldForm';

type SurveyFieldModalProps = {
  isOpen: boolean;
  initialValue?: SurveyField | null;
  onClose: () => void;
  onSubmit: (field: SurveyField) => void;
};

export const SurveyFieldModal = ({
  isOpen,
  initialValue,
  onClose,
  onSubmit,
}: SurveyFieldModalProps) => (
  <Modal
    size="2xl"
    isOpen={isOpen}
    onClose={onClose}
    scrollBehavior="inside"
    closeOnOverlayClick={false}
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{initialValue ? 'Edytuj pole ankiety' : 'Dodaj pole ankiety'}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Stack spacing={4}>
          <Text fontSize="sm" color="gray.600">
            Wprowadź treść pytania i skonfiguruj sposób odpowiedzi. Liczbę opcji możesz zmieniać w
            dowolnym momencie.
          </Text>
          <SurveyFieldForm
            key={initialValue?.id || 'new-field'}
            initialValue={initialValue ?? undefined}
            onSubmit={onSubmit}
            onCancel={onClose}
          />
        </Stack>
      </ModalBody>
    </ModalContent>
  </Modal>
);
